import React, { useState } from 'react';

function StatusIcon({ status }) {
	if (status === 'running') {
		return <span className="timeline-icon spinning">&#9696;</span>;
	}
	if (status === 'success') {
		return <span className="timeline-icon success">&#10003;</span>;
	}
	if (status === 'error') {
		return <span className="timeline-icon error">&#10007;</span>;
	}
	if (status === 'skipped') {
		return <span className="timeline-icon skipped">&#8212;</span>;
	}
	return <span className="timeline-icon pending">&#9675;</span>;
}

function PayloadViewer({ label, data, defaultOpen }) {
	const [open, setOpen] = useState(defaultOpen || false);

	if (!data) return null;

	return (
		<div className="payload-viewer">
			<button
				className="payload-toggle"
				onClick={() => setOpen(!open)}
			>
				{open ? '▾' : '▸'} {label}
			</button>
			{open && (
				<pre className="payload-json">
					{typeof data === 'string' ? data : JSON.stringify(data, null, 2)}
				</pre>
			)}
		</div>
	);
}

export default function ProcessingTimeline({ steps }) {
	return (
		<div className="processing-timeline">
			{steps.map((step, index) => (
				<div
					key={step.id}
					className={`timeline-step ${step.status}`}
				>
					<div className="timeline-connector">
						<StatusIcon status={step.status} />
						{index < steps.length - 1 && (
							<div className={`timeline-line ${step.status === 'success' || step.status === 'error' ? 'filled' : ''}`} />
						)}
					</div>
					<div className="timeline-content">
						<div className="timeline-header">
							<h4 className="timeline-title">{step.title}</h4>
							{step.duration && (
								<span className="timeline-duration">{step.duration}</span>
							)}
						</div>
						{step.description && (
							<p className="timeline-description">{step.description}</p>
						)}
						{step.endpoint && (
							<p className="timeline-endpoint">
								<span className="endpoint-method">POST</span> {step.endpoint}
							</p>
						)}
						{step.status === 'running' && (
							<div className="timeline-progress-bar">
								<div className="timeline-progress-fill" />
							</div>
						)}
						{step.request && (
							<PayloadViewer
								label="Request Payload"
								data={step.request}
								defaultOpen={step.status === 'error'}
							/>
						)}
						{step.response && (
							<PayloadViewer
								label="Response"
								data={step.response}
								defaultOpen={step.status === 'error' || step.status === 'success'}
							/>
						)}
						{step.error && (
							<div className="timeline-error">
								{step.error}
							</div>
						)}
					</div>
				</div>
			))}
		</div>
	);
}
